import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { useAppSelector } from 'hooks/reduxHooks'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { selectLoggedIn } from 'selectors/accountSelectors'
import useHasChatTripPlannerChats from './useHasChatTripPlannerChats'
import useHasClassicTripPlannerTrips from './useHasClassicTripPlannerTrips'

function useChatTripPlannerReleaseState(enabled = true) {
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const isChatTripPlannerReleaseEnabled = !!useOptimizelyExperiment(
    OptimizelyFeatureFlags.chatTripPlannerRelease,
    enabled,
  )
  const shouldLookUpChatTripPlannerChats =
    enabled && isLoggedIn && !isChatTripPlannerReleaseEnabled
  const {
    hasChatTripPlannerChats,
    hasChatTripLookupError,
    isLoadingChatTripPlannerChats,
  } = useHasChatTripPlannerChats(shouldLookUpChatTripPlannerChats)
  const hasChatTripPlannerDirectEntrySignal =
    isChatTripPlannerReleaseEnabled || hasChatTripPlannerChats
  const {
    hasClassicTripPlannerTrips,
    hasClassicTripLookupError,
    isLoadingClassicTripPlannerTrips,
  } = useHasClassicTripPlannerTrips(
    enabled && isLoggedIn && hasChatTripPlannerDirectEntrySignal,
  )
  const isLoadingChatTripPlannerDirectEntryDecision =
    isLoadingChatTripPlannerChats ||
    (hasChatTripPlannerDirectEntrySignal && isLoadingClassicTripPlannerTrips)
  const hasChatTripPlannerDirectEntryDecisionError =
    hasChatTripLookupError ||
    (hasChatTripPlannerDirectEntrySignal && hasClassicTripLookupError)

  return {
    isLoggedIn,
    isChatTripPlannerReleaseEnabled,
    hasChatTripPlannerChats,
    hasChatTripPlannerDirectEntrySignal,
    hasChatTripLookupError,
    isLoadingChatTripPlannerChats,
    hasClassicTripPlannerTrips,
    hasClassicTripLookupError,
    isLoadingClassicTripPlannerTrips,
    isLoadingChatTripPlannerDirectEntryDecision,
    hasChatTripPlannerDirectEntryDecisionError,
  }
}

export default useChatTripPlannerReleaseState
